import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CustomNavbar from "../../../components/CustomNavbar";
//import SidebarDashboard from '../../components/SidebarDashboard';
import CustomTable from "../../../components/CustomTable";
import {
  getChecklist,
  saveCheckList,
  editChecklist,
  deleteChecklist,
} from "../../../redux/checklist/actions";
import messages from "../../../redux/messages";
import SidebarConfig from "../../../components/SidebarConfig";
import { Formik } from "formik";
import * as Yup from "yup";

const FormDocuments = (props) => {
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const data = useSelector((store) => store.checklistDocs.checklist);
  const loading = useSelector((store) => store.checklistDocs.loading);
  const saveLoading = useSelector((store) => store.checklistDocs.saveLoader);

  const schema = Yup.object().shape({
    codigo: Yup.string().when("props", {
      is: () => props.match.params.type === "2",
      then: Yup.string().required("**Campo requerido"),
    }),
    nombre: Yup.string()
      .ensure()
      .required("**Campo requerido")
      .matches(
        /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/,
        "**Solo admite letras"
      ),
  });

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Fecha de creación",
      //accessor: 'fecha_creacion'
      Cell: (value) =>
        moment(value.row.original.fecha_creacion).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  const columns2 = [
    {
      Header: "Código",
      accessor: "codigo",
    },
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Fecha de creación",
      //accessor: 'fecha_creacion'
      Cell: (value) =>
        moment(value.row.original.fecha_creacion).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  useEffect(() => {
    dispatch(getChecklist(parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.type]);

  const addChecklist = () => {
    setShowModal(true);
    setEdit(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (!e.target.filter.value.trim()) {
      return;
    }
    dispatch(getChecklist(parseInt(props.match.params.type)));
  };

  const onSubmitChecklist = (req) => {
    const _req = {
      nombre: req.nombre,
      fecha_creacion: !edit
        ? moment().format("YYYY-MM-DD")
        : editItem.fecha_creacion,
    };

    if (props.match.params.type === "2") {
      _req.codigo = req.codigo;
    }

    if (!edit) {
      dispatch(saveCheckList(_req, parseInt(props.match.params.type)));
      setShowModal(false);
    } else {
      dispatch(
        editChecklist(
          _req,
          parseInt(props.match.params.type),
          index,
          editItem.id
        )
      );
      setShowModal(false);
    }
  };

  const seeAll = () => {
    dispatch(getChecklist(parseInt(props.match.params.type)));
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteChecklist(id, index, parseInt(props.match.params.type)));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              {parseInt(props.match.params.type) === 1
                ? "Documentos formal"
                : "Documentos funcional"}
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {/* <Col xs="auto">
                  <Form.Control
                  onChange={ e => setFilter(e.target.value)}
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type="search"></Form.Control>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">visibility</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addChecklist()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable
                    columns={
                      props.match.params.type === "2" ? columns2 : columns
                    }
                    data={data}
                  />
                </Card.Body>
              </Card>
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay documentos, comienza agregando algunos
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmitChecklist}
          initialValues={{
            codigo: edit ? editItem.codigo : "",
            nombre: edit ? editItem.nombre : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {edit ? "Editar documento" : "Crear documento"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {props.match.params.type === "2" ? (
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="12" md="4">
                      Código
                    </Form.Label>
                    <Col sm="12" md="8">
                      <Form.Control
                        id="codigo"
                        name="codigo"
                        className="rounded-pill"
                        type="text"
                        value={values.codigo}
                        placeholder="Código de documento"
                        onBlur={handleBlur("codigo")}
                        onChange={handleChange}
                        isValid={touched.codigo && !errors.codigo}
                        isInvalid={touched.codigo && errors.codigo}
                      ></Form.Control>
                      {touched.codigo && errors.codigo && (
                        <Col>
                          <small className="text-danger">{errors.codigo}</small>
                        </Col>
                      )}
                    </Col>
                  </Form.Group>
                ) : null}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Nombre de documento
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="nombre"
                      name="nombre"
                      className="rounded-pill"
                      type="text"
                      value={values.nombre}
                      placeholder="Nombre de documento"
                      onBlur={handleBlur("nombre")}
                      onChange={handleChange}
                      isValid={touched.nombre && !errors.nombre}
                      isInvalid={touched.nombre && errors.nombre}
                    ></Form.Control>
                    {touched.nombre && errors.nombre && (
                      <Col>
                        <small className="text-danger">{errors.nombre}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default FormDocuments;
